<template>
  <div class="laboratory">
    <common-layout>
      <div slot="header">
        <h3>重点实验室</h3>
      </div>
      <div slot="container">
        <div class="laboratory-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623AA2; border: none;"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteAll"
          >批量删除</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear='search'
            style="width:240px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <label>级别:</label>
          <el-select style="width:140px" v-model="levelValue" clearable placeholder="全部" @change='search'>
            <el-option
              v-for="(item,index) in levelOptionsSelect"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="laboratory-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
            ></el-table-column>

            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="名称"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column
              label="简介"
              align="center"
            >
              <template slot-scope="scope">
                <span style="display:block;height:23px;overflow: hidden;">{{GetTarg(scope.row.introduction)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="日期"
              align="center"
              prop="dateTime"
            >
            </el-table-column>
            <el-table-column
              label="是否推荐"
              align="center"
              prop="hot"
            >
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.hot == 1"
                  type="success"
                  effect="plain">
                  是
                </el-tag>
                <el-tag
                  v-else
                  type="danger"
                  effect="plain">
                  否
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              width="240px"
              align="center"
              label="操作"
            >
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.hot == 2"
                >推荐资源</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button> -->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        >
        </el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal='false'
    >
      <el-form
        :model="ruleForm"

        ref="ruleForm"
        label-width="120px"
      >
      <el-row>
        <el-col :span="12">
          <el-row>
            <el-form-item
              label="实验名称"
              prop="name"
            >
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入实验名称"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label="研究领域"
              prop="field"
            >
              <el-input
                v-model="ruleForm.field"
                placeholder="请输入研究领域"
              ></el-input>
              <!-- <el-select multiple style="width:100%" v-model="ruleForm.field" placeholder="请选择">
                <el-option
                  v-for="item in fieldOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label="级别"
              prop="level"
            >
              <el-select multiple style="width:100%" v-model="ruleForm.level" placeholder="请选择">
                <el-option
                  v-for="item in levelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label="实验室类别"
              prop="A014"
            >
              <el-select multiple style="width:100%" v-model="ruleForm.A014" placeholder="请选择">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="logo"
            prop="logo"
          >
            <el-upload class="avatar-uploader" :action="this.uploadURL" name="file" :show-file-list="false" :on-success="handlePictureCardPreview"
				  	 :before-upload="beforeAvatarUpload" :http-request="HouImgFile">
				  		<img v-if="ruleForm.logo" :src="imgUrl+ruleForm.logo" class="img_border" v-real-img="ruleForm.logo" />
				  		<i v-else class="el-icon-plus avatar-uploader-icon" :class="{is_border: !ruleForm.logo}"></i>
				  		<span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
				  		<span v-else class="upload_btn">更换图片</span>
				  	</el-upload>
				  	<span class="del_img" v-show="ruleForm.logo">
				  		<i class="el-icon-error" @click="deleteImg"></i>
				  	</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="学科领域" prop="A015">
            <el-input v-model="ruleForm.A015" placeholder="请输入学科领域"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="主要研究方向" prop="A016">
            <el-input v-model="ruleForm.A016" placeholder="请输入主要研究方向"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="依托单位" prop="A017">
            <el-input v-model="ruleForm.A017" placeholder="请输入依托单位"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
          <el-form-item
            label="建设地址"
            prop="address"
          >
          	<v-distpicker style="text-align:left;" @selected="citySelected" :province="ruleForm.address.province.value" :city="ruleForm.address.city.value"
						:area="ruleForm.address.area.value"></v-distpicker>
            <el-input style="margin-top:10px" v-model="ruleForm.detailed" placeholder="请填写详细地址"></el-input>
          </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="实景图"
          style="text-align:center"
        >
          <el-upload
            style="text-align:left"
            :action="this.uploadURL"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="pictureCardPreview1"
            :before-upload="beforeUpload1"
            :on-remove="handleRemove1"
            :http-request="HouImgFile1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="实验室主任姓名">
            <el-input v-model="ruleForm.A002" placeholder="请填写实验室主任姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实验室主任专业">
            <el-input v-model="ruleForm.A003" placeholder="请填写实验室主任专业"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
     <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="实验室主任职务">
            <el-input v-model="ruleForm.A004" placeholder="请填写实验室主任职务"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实验室主任职称">
            <el-input v-model="ruleForm.A005" placeholder="请填写实验室主任职称"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="人员总数">
            <el-input v-model.number="ruleForm.A006" placeholder="请填写人员总数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="研究及技术人员数" class="special">
            <el-input v-model.number="ruleForm.A007" placeholder="请填写研究及技术人员数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="重点实验室面积(平方米)" class="special">
            <el-input v-model.number="ruleForm.A008" placeholder="请填写重点实验室面积"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备总值">
            <el-input v-model.number="ruleForm.A009" placeholder="请填写设备总值"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="原值十万元以上设备台件数" class="special">
            <el-input v-model.number="ruleForm.A010" placeholder="请填写原值十万元以上设备台件数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设施设备是否已开放共享" class="special" style="text-align:left">
            <el-switch
              v-model="ruleForm.A011"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="组建方式">
            <el-select style="width:100%" v-model="ruleForm.A012" placeholder="请选择" @change="selectWay">
              <el-option
                v-for="item in wayOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button icon="el-icon-plus" type="success" @click="addWay" :disabled="ruleForm.A012==2?false:true">新增联合单位</el-button>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12" v-for="(item,index) in ruleForm.A013" :key="index">
          <el-form-item :label="'联合单位' + (index + 1)" style="text-align: left;">
            <el-input :disabled="ruleForm.A012==2?false:true" style="width:calc(100% - 50px);margin-right:10px;" v-model="item.name"></el-input><el-button v-show="index !==0" type="danger" icon="el-icon-delete" circle @click="removeWay(item)"></el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item label="实验室简介" prop="introduction">
          	<!-- <editor refName='introduction' :placeholder="'请填写包括实验室研究方向和主要研究内容、科研队伍状况、国内外该领域最新进展，发展趋势、应用前景等方面'" :quill-data="ruleForm.introduction" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          	<editor refName='introduction' :placeholderText="'请填写包括实验室研究方向和主要研究内容、科研队伍状况、国内外该领域最新进展，发展趋势、应用前景等方面'" v-model="ruleForm.introduction" :upload-url="uploadURL" :img-show-url="imgUrl"></editor>
        </el-form-item>
      </el-row>
      <div style="display:flex;align-items:center;justify-content: space-between;margin-bottom: 15px;">
        <h3 style="margin:0">取得研究成果</h3>
        <el-button icon="el-icon-plus" type="success" @click="addRes">新增研究成果</el-button>
      </div>
      <el-row v-for="(item,index) in ruleForm.A001" :key="index" style="border:1px solid #799ae1;margin-bottom:5px;padding-top:10px">
        <el-col :span="7">
          <el-form-item label="名称" :prop="'A001.' + index + '.name'"
     >
            <el-input v-model="item.name" placeholder="请填写研究成果名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item class="special" label="获国家或省级奖" :prop="'A001.' + index + '.prize'"
     >
            <el-input v-model="item.prize" placeholder="请填写研究成果获国家或省级奖"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="批准专利" :prop="'A001.' + index + '.patent'"
    >
            <el-input v-model="item.patent" placeholder="请填写研究成果批准专利"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-show="index!=0">
          <el-button type="danger" icon="el-icon-delete" circle @click="removeRes(item)"></el-button>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-form-item label="取得成果" prop="achievement">
          	<editor refName='achievement' :placeholder="'请填写实验室现有研究工作的基础、水平（国内外影响和地位；近5年承担的重大科研任务和取得的代表性科研成果；在推动技术发展、解决国家经济和社会发展重大关键问题等方面的贡献）'" :quill-data="ruleForm.achievement" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData1"></editor>
        </el-form-item>
      </el-row> -->
      <!-- <el-row>
        <el-form-item label="科研条件" prop="condition">
          	<editor refName='condition' :placeholder="'请填写已具备的科研条件（科研用房、仪器设备、配套设施）'" :quill-data="ruleForm.condition" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData2"></editor>
        </el-form-item>
      </el-row> -->
      <el-row>
        <el-col :span="5">
          <el-form-item style="text-align:left" label="是否推荐" prop="hot">
            <el-switch
              v-model="ruleForm.hot"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="推荐度" prop="hotOrder">
            <!-- <el-input v-model.number="ruleForm.hotOrder" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
            <el-slider v-model="ruleForm.hotOrder" show-input :disabled="ruleForm.hot == 2"></el-slider>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      />
    </el-dialog>
  </div>

</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
export default {
  components: {
    CommonLayout,
    editor
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if(this.ruleForm.hot == 1){
        if (!value) {
          callback(new Error('请设置推荐度'));
        }
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        }else {
          callback();
        }
      }else{
        callback();
      }
    };
    return {
      levelValue:'',
      is_submit : true,
      total: 10,
      per_page: 10,
      current_page: 1,
      type:0,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible:false,
      dialogImageUrl:'',
      deleteRow: "",
      fileList:[],
      tableData: [],
      wayOptions:[
        {
          value: 1,
          label: '独立组建'
        },
        {
          value: 2,
          label: '联合组建'
        },
      ],
      typeOptions:[
        {
          value: '001',
          label: '学科类'
        },
        {
          value: '002',
          label: '企业类'
        },
        {
          value: '003',
          label: '省市共建类'
        },
      ],
      levelOptions:[

        {
          value: '001',
          label: '省级'
        },
        {
          value: '002',
          label: '国家级'
        },
        // {
        //   value: 3,
        //   label: '试验发展'
        // },
      ],
      levelOptionsSelect:[


        {
          value: '',
          label: '全部'
        },
        {
          value: '001',
          label: '省级'
        },
        {
          value: '002',
          label: '国家级'
        },
        // {
        //   value: 3,
        //   label: '试验发展'
        // },
      ],
      fieldOptions:[
        {
          value: '001',
          label: '新能源'
        },
        // {
        //   value: '002',
        //   label: '清洁生产'
        // },
        // {
        //   value: '003',
        //   label: '清洁能源'
        // },
        {
          value: '004',
          label: '现代农业'
        },
        {
          value: '005',
          label: '生物医药'
        },
        {
          value: '006',
          label: '文化旅游'
        },
        {
          value: '007',
          label: '通道物流'
        },
        {
          value: '008',
          label: '数据信息'
        },
        {
          value: '009',
          label: '军民融合'
        },
        {
          value: '010',
          label: '装备制造'
        },
        {
          value: '011',
          label: '新材料',
        },
      ],
      ruleForm: {
        name:'',
        logo:'',
        image:'',
        address: {
					province: {
						value: "甘肃省"
					},
					city: {
						value: "兰州市"
					},
					area: {
						value: "城关区"
					}
				},
				detailed: "",
        level:[],
        field:'',
        introduction:'',
        achievement:'',
        condition:'',
        dateTime:new Date().format("yyyy-MM-dd hh:mm:ss"),
        hot:2,
        hotOrder:0,
        A002:'',
        A003:'',
        A004:'',
        A005:'',
        A006:'',
        A007:'',
        A008:'',
        A009:'',
        A010:'',
        A015:'',
        A016:'',
        A017:'',
        A011:2,
        A014:[],
        A001:[
          {
            name:'',
            prize:'',
            patent:'',
          }
        ],
        A012:'',
        A013:[
          {
            name:'',
          }
        ]
      },
      rules: {
        name:[{required: true, message: '请输入实验名称', trigger: 'blur'}],
        logo: [{required: true, message: "请上传logo", trigger: "blur" }],
        A014:[{required: true, message: '请选择实验室类别', trigger: 'change'}],
        level:[{required: true, message: '请选择级别', trigger: 'change'}],
        field:[{required: true, message: '请输入研究领域', trigger: 'blur'}],
        introduction:[{required: true, message: '请输入实验室简介', trigger: 'blur'}],
        achievement:[{required: true, message: '请输入取得成果', trigger: 'blur'}],
        condition:[{required: true, message: '请输入科研条件', trigger: 'blur'}],
        hotOrder:[{required: true, validator:validateHoto, trigger: 'blur'}]
      }
    };
  },
  created() {
    this.getData("Resource_Laboratory?all=1&page="+this.current_page);
  },
  methods: {
    // release(row,type){
    //   let obj = {};
    //   obj.id = row.id;
    //   obj.type = 9;
    //   obj.hot = 1;
    // },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-laboratory/page`, params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //富文本
		getQuillData(val) {
			this.ruleForm.introduction = val;
		},
		// getQuillData1(val) {
		// 	this.ruleForm.achievement = val;
		// },
		// getQuillData2(val) {
		// 	this.ruleForm.condition = val;
    // },
    //城市选择
		citySelected(e) {
			this.ruleForm.address = e;
    },
    //新增联合单位
    addWay(){
      this.ruleForm.A013.push({
        name: '',
      });
    },
    //删除联合单位
    removeWay(item){
      var index = this.ruleForm.A013.indexOf(item)
      if (index !== -1) {
        this.ruleForm.A013.splice(index, 1)
      }
    },
    selectWay(){
      if(this.ruleForm.A012 == 1){
        this.ruleForm.A013= [
          {
            name:''
          }
        ]
      }
    },
    //新增研究成果
    addRes(){
      this.ruleForm.A001.push({
        name: '',
        prize: '',
        patent: '',
      });
    },
    //删除研究成果
    removeRes(item){
      var index = this.ruleForm.A001.indexOf(item)
        if (index !== -1) {
          this.ruleForm.A001.splice(index, 1)
        }
    },
    //新增
    addEvent() {
      this.is_submit = true
      if(this.$refs['ruleForm']){
        this.$refs['ruleForm'].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.fileList = []
      this.ruleForm = {
        name:'',
        logo:'',
        image:'',
        address: {
					province: {
						value: "甘肃省"
					},
					city: {
						value: "兰州市"
					},
					area: {
						value: "城关区"
					}
				},
				detailed: "",
        level:[],
        field:'',
        introduction:'',
        achievement:'',
        condition:'',
        dateTime:'',
        hot:2,
        hotOrder:0,
        A002:'',
        A003:'',
        A004:'',
        A005:'',
        A006:'',
        A007:'',
        A008:'',
        A009:'',
        A010:'',
        A015:'',
        A016:'',
        A017:'',
        A011:2,
        A014:[],
        A001:[
          {
            name:'',
            prize:'',
            patent:'',
          }
        ],
        A012:'',
        A013:[
          {
            name:'',
          }
        ]
      }
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
					this.$confirm("此操作将批量删除, 是否继续?", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
							center: true
						})
						.then(() => {
							this.http
								.request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-laboratory/batchDelete?ids=` + this.deleteRow, "", "delete")
								.then(res => {
									if (res.code == 0) {
										this.getData("Resource_Laboratory?all=1&page=1");
										this.$message({
											type: "success",
											message: "删除成功"
                    });
                  this.ResetSearch(['searchValue','levelValue'])

									} else {
										this.$message({
											message: "失败！",
											type: "error"
										});
									}
								});
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消删除"
							});
						});
				} else {
					this.$message({
						type: "warning",
						message: "请选择删除的记录"
					});
				}
    },
    //搜索
    search() {
      this.current_page = 1
      this.getData("Resource_Laboratory?all=1&name=" + this.searchValue+"&page="+this.current_page
      +(this.levelValue?"&level="+this.levelValue:'')
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach(item => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true
      this.dialogFormVisible = true;
      this.Title = '编辑'
      row.detailed = row.address?row.address.detailed:''
      row.address = row.address?row.address:{province: {value: ""},city: {value: ""},area: {value: ""}}
      this.ruleForm = JSON.parse(JSON.stringify(row))
      this.ruleForm.level = row.level.split(',')
      this.ruleForm.A014 = row.A014?.split(',')
      this.ruleForm.A013 = (row.A013=='null' || !row.A013)?[{name:''}]:JSON.parse(row.A013)
      this.ruleForm.A001 = (row.A001=='null' || !row.A001)?[{name:'',prize:'',patent:''}]:JSON.parse(row.A001)
      // this.ruleForm.detailed = row.address.detailed
      this.fileList = []
			if (row.image) {
				let arr = [];
				arr = row.image.split(',')
				arr.forEach((item, index) => {
					this.fileList.push({
						name: "download.jpg",
						url: this.imgUrl + item,
						store_result: item,
						uid: new Date().getTime() + index
					})
				})
			}
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					})
					.then(() => {
						this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-laboratory/delete?id=` + row.id, "", "delete").then(res => {
							if (res.code == 0) {
								this.getData("Resource_Laboratory?all=1&page="+this.current_page);
								this.$message({
									type: "success",
									message: "删除成功"
                });
                  this.ResetSearch(['searchValue','levelValue'])

							} else {
								this.$message({
									message: "失败！",
									type: "error"
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
    },
    //翻页
    handleCurrentChange(e) {
      this.getData("Resource_Laboratory?all=1&name=" + this.searchValue + '&page=' + e+(this.levelValue?"&level="+ this.levelValue : ''));
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //获取经纬度
     factory(name) {
        this.$jsonp(
        "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.ruleForm.detailed +
          "&city="+this.ruleForm.address.city.value+"&children=1&offset=20&page=1&extensions=all"
      )
          .then(json => {
            let arr = json.pois[0].location.split(",");
            this.ruleForm.longitude = arr[0];
            this.ruleForm.latitude = arr[1];
            this.subData(name)
          })
          .catch(err => {
            this.is_submit = true
            this.$message.error("未获取到经纬度,请查看地址是否完整");
          });
    },
    subData(name){
      let obj = JSON.parse(JSON.stringify(this.ruleForm))
          let arr = [];
          this.fileList.forEach(item => {
            if (item.response) {
              arr.push(item.response.data.store_result);
            } else {
              arr.push(item.store_result);
            }
          });
          obj.image = arr.join(",");
          obj.address.detailed = this.ruleForm.detailed
          obj.level = this.ruleForm.level.join(',')
          obj.A014 = this.ruleForm.A014.join(',')
          obj.A013 = JSON.stringify(this.ruleForm.A013)
          obj.A001 = JSON.stringify(this.ruleForm.A001)
          obj.dateTime = new Date().format("yyyy-MM-dd hh:mm:ss")
          let area = [
            {
              name: "兰州市",
              id: "001"
            },
            {
              name: "嘉峪关市",
              id: "002"
            },
            {
              name: "金昌市",
              id: "003"
            },
            {
              name: "白银市",
              id: "004"
            },
            {
              name: "天水市",
              id: "005"
            },
            {
              name: "武威市",
              id: "006"
            },
            {
              name: "张掖市",
              id: "007"
            },
            {
              name: "酒泉市",
              id: "008"
            },
            {
              name: "平凉市",
              id: "009"
            },
            {
              name: "庆阳市",
              id: "010"
            },
            {
              name: "定西市",
              id: "011"
            },
            {
              name: "陇南市",
              id: "012"
            },
            {
              name: "临夏回族自治州",
              id: "013"
            },
            {
              name: "甘南藏族自治州",
              id: "014"
            }
          ];
          area.forEach(item=>{
            if(obj.address.city.value == item.name){
              obj.area = item.id
            }
          })
          if(obj.hot == 2){
            obj.hotOrder = 0
          }
          obj.condition = `<p>重点实验室面积${obj.A008 || 0}平方米,设备总值${obj.A009 || 0}万元,原值十万元以上设备${obj.A010 || 0}件,${obj.A011==1?'设施设备已开放共享':''}</p>`
          delete obj.detailed
          if (!this.ruleForm.id) {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-laboratory/create`,obj).then(res=>{
              if(res.code == 0){
                this.getData("Resource_Laboratory?all=1&page=1")
                this.$message({
									type: "success",
									message: "新增成功"
								});
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
                  this.ResetSearch(['searchValue','levelValue'])

                let obj1={
                  name:obj.name,
                  moudle:'重点实验室',
                  date_time:obj.dateTime
                }
                // this.http.post('Index_Resource',obj1)
                this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/index-resource/create`, obj1);
              } else {
                this.is_submit = true
              }
            }).catch(err => {
              this.is_submit = true;
            })
          }else{
            // delete obj.id
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-laboratory/update`,obj).then(res=>{
              if(res.code == 0){
                this.getData("Resource_Laboratory?all=1&page=1")
                this.$message({
									type: "success",
									message: "编辑成功"
                });
                  this.ResetSearch(['searchValue','levelValue'])

                this.dialogFormVisible = false;
                this.$refs[name].resetFields();

              } else {
                this.is_submit
              }
            }).catch(err => {
              this.is_submit = true;
            })
          }
    },
    //提交
    submitForm(name) {
      if(!this.is_submit)  return false
      this.is_submit = false
      this.$refs[name].validate(valid => {
        if (valid) {
          this.factory(name)
        } else {
          this.is_submit = true
          return false;
        }
      });
    },
    //上传图片
		HouImgFile(e) {
				var files = e.file;
				if (!files) return;
				this.createImage(files, e, "HouImg");
		},
		//其他图片上传
		createImage(file, e, Name) {
				//lrz压缩
				// lrz图片先压缩在加载、
				lrz(file, {
						width: 960
					})
					.then(rst => {
						this.http
							.post("/file/base64_upload", {
								image: rst.base64
							})
							.then(res => {
								this.ruleForm.logo = res.data;
							});
						return rst;
					})
					.always(() => {
						// 清空文件上传控件的值
						e.target.value = null;
					});
		},
		handlePictureCardPreview(file) {
				this.ruleForm.logo = file.data.store_result;
		},
		beforeAvatarUpload(file) {
				let type = false;
				if (
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpg" ||
					file.type === "image/gif" ||
					file.type === "image/bmp"
				) {
					type = true;
				}

				const isLt2M = file.size / 1024 / 1024 < 10;
				if (!type) {
					this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 10MB!");
				}
				return type && isLt2M;
		},
		deleteImg() {
				this.$confirm("确定删除图片吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					})
					.then(() => {
						this.ruleForm.logo = "";
						this.$message({
							type: "success",
							message: "删除成功!"
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
    },
    //上传照片墙
    HouImgFile1(e) {
        var files = e.file;
        if (!files) return;
        this.createImage1(files, e, "HouImg");
    },
    //其他图片上传
    createImage1(file, e, Name) {
        //lrz压缩
        // lrz图片先压缩在加载、
        lrz(file, {
            width: 960
        })
            .then(rst => {
                this.http
                  .post("/file/base64_upload", {
                    image: rst.base64
                  })
                  .then(res => {
                    this.fileList.push({
				            	name: file.name,
				            	url: this.imgUrl + res.data,
				            	store_result: res.data,
				            	uid: file.uid
				            })
                  });
                return rst;
            })
            .always(() => {
                // 清空文件上传控件的值
                e.target.value = null;
            });
    },
    //移除
    handleRemove1(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload1(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview1(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss" scope>
.laboratory {
  height: 100%;
  width: 100%;
  .laboratory-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    /deep/.el-input--suffix{
      width: 100%
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .laboratory-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
		.is_border {
			border: 1px dashed #ddd !important;
			border-radius: 5px;
			height: 154px !important;
			line-height: 154px !important;
		}

		.upload_btn {
			display: block;
			background-color: #00a1ff;
			font-weight: bold;
			color: #fff;
			padding: 2px;
			border-bottom-left-radius: 3px;
			border-bottom-right-radius: 3px;
		}

		.upload_btn:hover {
			background-color: #13ce66;
		}

		.del_img {
			position: absolute;
			top: -7px;
			left: 224px;
			color: #00a1ff;
		}

		.del_img:hover {
			cursor: pointer;
			color: #f00;
		}

		.del_img i:before {
			font-size: 20px;
		}

		.img_border {
			border-top-left-radius: 3px;
			border-top-right-radius: 3px;
			width: 243px;
			height: 154px;
			display: block;
		}

		.avatar-uploader {
			text-align: center;
			width: 243px;
			height: 198px;
		}

		/deep/ .el-upload {
			border: 1px dashed #d9d9d9 !important;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		/deep/ .el-upload:hover {
			border-color: #409eff !important;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 243px;
			height: 154px;
			line-height: 154px;
			text-align: center;
		}
}
</style>
